import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router";

import { SuiviContactDetailPage, SuiviContactListPage } from ".";

export interface SuiviContactProps {}

export const SuiviContact: React.FunctionComponent<SuiviContactProps> = props => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}`} exact>
        <SuiviContactListPage />
      </Route>
      <Route path={`${match.path}/:suiviId?`} component={SuiviContactDetailPage} exact />
    </Switch>
  );
};
